import styled, { createGlobalStyle } from 'styled-components';

export const OutsideArea = createGlobalStyle`
  body {
    /* For some reason iOS Safari requires a pointer cursor to trigger click events... */
    cursor: pointer;
  }
`;

export const InsideArea = styled.div`
  cursor: default;
  height: 100%;
`;
